var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79309 0.606925C6.99661 -0.0194372 7.88275 -0.0194364 8.08626 0.606926L9.19502 4.01932C9.28604 4.29944 9.54707 4.48909 9.84161 4.48909H13.4296C14.0882 4.48909 14.362 5.33186 13.8292 5.71897L10.9265 7.82794C10.6882 8.00107 10.5885 8.30793 10.6795 8.58805L11.7882 12.0004C11.9918 12.6268 11.2749 13.1477 10.7421 12.7606L7.83929 10.6516C7.60101 10.4785 7.27835 10.4785 7.04007 10.6516L4.1373 12.7605C3.60449 13.1477 2.88759 12.6268 3.09111 12.0004L4.19986 8.58805C4.29088 8.30793 4.19117 8.00107 3.95289 7.82794L1.05013 5.71897C0.517314 5.33186 0.791144 4.48909 1.44974 4.48909H5.03775C5.33228 4.48909 5.59332 4.29944 5.68433 4.01932L6.79309 0.606925Z",
    fill: "#7D8592"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.4299ac9001ffa7ff3248aa1946d8c06a.svg";
export { ForwardRef as ReactComponent };